import React from "react";
import { Link } from "react-router-dom";
import PageSEO from "../components/SEO";
import CatalogHiddenBanner from "../components/CatalogHiddenBanner";
import useContent from "../lib/content";
import { useShop } from "../lib/shop-context";

/**
 * Fase 4 · CMS — página pública "Sobre nosotros". El contenido (title,
 * body_md) proviene del CMS admin; el body se renderiza como texto plano
 * con saltos de línea preservados (párrafos por doble newline).
 */
export default function AboutPage() {
  const { fields } = useContent("about");
  const shopCtx = useShop();
  const paragraphs = String(fields.body_md || "")
    .split(/\n{2,}/)
    .map((p) => p.trim())
    .filter(Boolean);

  // Si el catálogo está oculto (solo aplica cuando estamos dentro de un shop
  // shell) no bloqueamos "Sobre nosotros" — es una página informativa.
  void shopCtx;

  return (
    <div className="mx-auto max-w-3xl px-4 sm:px-6 py-8 sm:py-14">
      <PageSEO
        title={fields.seo_title || "Sobre nosotros"}
        description={fields.seo_description}
        canonical="https://mercago.one/sobre-nosotros"
      />
      <nav className="text-xs text-neutral-500 mb-4">
        <Link to="/" className="hover:underline">
          Inicio
        </Link>{" "}
        · Sobre nosotros
      </nav>
      <h1
        data-testid="about-page-title"
        className="text-4xl sm:text-5xl font-black tracking-tight"
      >
        {fields.title || "Sobre MercaGo"}
      </h1>
      <div
        data-testid="about-page-body"
        className="mt-6 space-y-4 text-neutral-700 leading-relaxed"
      >
        {paragraphs.length === 0 ? (
          <p className="text-neutral-500 italic">
            Estamos preparando esta sección.
          </p>
        ) : (
          paragraphs.map((p, i) => <p key={i}>{p}</p>)
        )}
      </div>
    </div>
  );
}
